var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"big-loader"},[_c('transition',{attrs:{"name":"fade"}},[_c('span',{staticClass:"bouncer"},_vm._l((3),function(num){return _c('i',{class:'bounce-' + num})}),0)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }